import * as React from 'react';

import {createIcon} from '@chakra-ui/icons';

export const CoordDotsIcon = createIcon({
  displayName: 'CoordDotsIcon',
  viewBox: '0 0 24 24',
  path: (
    <g fill='currentColor'>
      <circle cx='5.2' cy='6.4' r='2.9' />
      <circle cx='13' cy='4.4' r='2.4' />
      <circle cx='19.4' cy='9.6' r='2.8' />
      <circle cx='6.8' cy='14.8' r='2.6' />
      <circle cx='14.4' cy='13.4' r='3.2' />
      <circle cx='10.6' cy='20.2' r='2.7' />
    </g>
  ),
});
